export const LuxeMonogramMark = ({ letters = "SS", size = "md", className = "", ...rest }) => {
  const dims = size === "lg" ? "h-24 w-24 text-4xl" : size === "sm" ? "h-9 w-9 text-sm" : "h-11 w-11 text-base";
  return (
    <span
      className={`relative inline-flex items-center justify-center rounded-full border border-[hsl(var(--gold)/0.7)] font-display !tracking-[-0.04em] text-foreground ${dims} ${className}`}
      {...rest}
    >
      <span className="absolute inset-[3px] rounded-full border border-[hsl(var(--gold)/0.25)]" aria-hidden="true" />
      <span className="relative">{letters}</span>
    </span>
  );
};
